module.exports = __webpack_public_path__ + "2f90176c5dda5cba521e5a87fa269464.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-cowboy.png
// module id = 1880
// module chunks = 0